// removed by extract-text-webpack-plugin
module.exports = {"commentbtn":"jdimGVdZZDE-sFCf19TeU","commentbox":"V_Mrg0mHBDZMv9Y-rw1U4","subCommentBox":"_2ylIx9rtiMeTohHRAfX7zc","carregarmais":"_3XzKq2rI3IBLgFQarWVIk6","subcommentbtn":"_14Hze8FqgjDpQ3P6CmcyPG","btnlink":"_3ZqaGnNtdgBXadQaFZrs9e","createComment":"_2H-aIECtM4EZXuffqLfDlT"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/organisms/Timeline/Comments/style.css
// module id = 685
// module chunks = 38